module.exports = __webpack_public_path__ + "img/Starter-Set-Party-long-rest.74a0188e.jpg";